// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "94a47abdce70";
export const BUILD_VERSION_NUMBER = 39;
